import { promoSourceFromCookieOrQuery } from 'utils/promoUtils';

import useLocation from '@skippay/core/hooks/useLocation';

const usePromoSource = (): string => {
	const {
		location: { query },
	} = useLocation();

	return promoSourceFromCookieOrQuery(query);
};

export default usePromoSource;
